/** Format 24-hour fluid net for task/list badges. */

export function formatSignedNetMl(net) {
  const value = Number(net);
  const amount = Number.isFinite(value) ? value : 0;
  if (amount > 0) return `+${amount}`;
  return String(amount);
}

export function formatFluidNetBadge(t, net) {
  return t('fluidBalanceNetBadge', { net: formatSignedNetMl(net) });
}
